import { useEffect, useState } from 'react';

// Ancho de celular: por debajo de 768 px el menú lateral pasa a panel
// superpuesto (bloque 5c, §17 ítem 86).
export const CONSULTA_MOVIL = '(max-width: 767.98px)';

function coincide(consulta: string): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    && window.matchMedia(consulta).matches;
}

export function useMediaQuery(consulta: string): boolean {
  const [activa, setActiva] = useState(() => coincide(consulta));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(consulta);
    const alCambiar = () => setActiva(mql.matches);
    alCambiar();
    mql.addEventListener('change', alCambiar);
    return () => mql.removeEventListener('change', alCambiar);
  }, [consulta]);

  return activa;
}
